import React from "react"
import "./Sidebar.css"
import AnchorLink from "react-anchor-link-smooth-scroll"

const Sidebar = props => {
  let sidebarClasses = "sidebar"
  if (props.show) {
    sidebarClasses = "sidebar show"
  }

  return (
    <nav className={sidebarClasses}>
      <ul>
        <li>
          <AnchorLink
            href="#home-page"
            offset="0"
            className="linkTo"
            onClick={props.hide}
          >
            Home
          </AnchorLink>
        </li>
        <li>
          <AnchorLink
            href="#about-page"
            offset="0"
            className="linkTo"
            onClick={props.hide}
          >
            About
          </AnchorLink>
        </li>
        <li>
          <AnchorLink
            href="#gallery-page"
            offset="0"
            className="linkTo"
            onClick={props.hide}
          >
            Gallery
          </AnchorLink>
        </li>

        <li>
          <AnchorLink
            href="#services-page"
            offset="0"
            className="linkTo"
            onClick={props.hide}
          >
            Services
          </AnchorLink>
        </li>

        <li>
          <AnchorLink
            href="#testimonials-page"
            offset="0"
            className="linkTo"
            onClick={props.hide}
          >
            Testimonials
          </AnchorLink>
        </li>
        <li>
          <AnchorLink
            href="#contact-page"
            offset="0"
            className="linkTo"
            onClick={props.hide}
          >
            Contact
          </AnchorLink>
        </li>
      </ul>
    </nav>
  )
}

export default Sidebar
